export const channelTypes = {
  livechat: 'widget',
  social: ['social', 'facebook', 'instagram'],
  forwarding: 'forwarding',
  google: 'google',
  facebook: 'facebook',
  instagram: 'instagram',
  twitter: 'twitter',
  chat: ['social', 'widget', 'facebook', 'instagram'],
  inboxes: ['forwarding', 'google', 'twitter'],
}

export const keyFromChannelType = channelType => {
  if (!Array.isArray(channelType)) return channelType

  return channelType.join('-')
}

export const isChatChannelType = channelType => {
  return channelTypes.chat.includes(channelType)
}

export const isBridgeChannelType = channelType => {
  return channelTypes.social.includes(channelType)
}

export const isEmailChannelType = channelType => {
  return channelTypes.inboxes.includes(channelType)
}
